import './CartHeader.css';
import React from 'react';
import { useSelector } from 'react-redux';
import { ShoppingBag } from 'lucide-react';

const CartHeader = () => {
    const cartAmount = useSelector((state) => state.cart.cartAmount);
    return <a href="/cart" className="mg-header-top-actions__link" aria-label="Корзина"><ShoppingBag aria-hidden="true" />{cartAmount > 0 && <span className="cart-count">{cartAmount}</span>}</a>;
};

export default CartHeader;
